
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M960 672a96 96 0 0 1-96 96H160a96 96 0 0 1-96-96V224a96 96 0 0 1 96-96h704a96 96 0 0 1 96 96v448z m-64 0V224a32 32 0 0 0-28.256-31.776L864 192H160a32 32 0 0 0-31.776 28.256L128 224v448a32 32 0 0 0 28.256 31.776L160 704h704a32 32 0 0 0 31.776-28.256L896 672zM800 832a32 32 0 0 1 3.744 63.776L800 896H224a32 32 0 0 1-3.744-63.776L224 832h576z",
        "fill": "#ffffff"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M608 288a32 32 0 0 1 3.744 63.776L608 352H224a32 32 0 0 1-3.744-63.776L224 288h384zM352 416a32 32 0 0 1 3.744 63.776L352 480H224a32 32 0 0 1-3.744-63.776L224 416h128zM528 736a32 32 0 0 1 31.776 28.256L560 768v71.776a32 32 0 0 1-63.776 3.712l-0.224-3.712V768a32 32 0 0 1 32-32z",
        "fill": "#ffffff"
      }
    }
  ]
})
    }
  